import React from "react"
import deepEqual from "deep-equal"

interface Options {
  enabled?: boolean
}

export function useDripTrack(eventName: string, data: Record<any, any>, options?: Options) {
  const submittedData = React.useRef<any>()
  React.useEffect(() => {
    if (options && !options.enabled) return
    const dcq = (window as any)._dcq
    if (dcq && !deepEqual(submittedData.current, data)) {
      dcq.push(["track", eventName, data])
      submittedData.current = { ...data }
    }
  }, [eventName, data, options])
}
